function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  fill: "#547982",
  height: 102,
  rx: 4.128,
  width: 60.84,
  x: 18.25,
  y: 13
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m79.09 30.1h26.42a4.241 4.241 0 0 1 4.241 4.241v48.725a4.241 4.241 0 0 1 -4.241 4.241h-26.42a0 0 0 0 1 0 0v-57.207a0 0 0 0 1 0 0z",
  fill: "#6ae1db"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m25.968 21.5h45.403v20.431h-45.403z",
  fill: "#6ae1db"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m55.253 51.465h16.118v8.399h-16.118z",
  fill: "#e43c53"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m55.253 66.75h16.118v8.399h-16.118z",
  fill: "#69b921"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m55.253 82.034h16.118v23.958h-16.118z",
  fill: "#fbbe2c"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  fill: "#ececf1"
}, /*#__PURE__*/React.createElement("path", {
  d: "m25.628 51.465h8.4v8.4h-8.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.27 51.465h8.399v8.4h-8.399z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.628 66.75h8.4v8.399h-8.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.27 66.75h8.399v8.399h-8.399z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.628 82.034h8.4v8.399h-8.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.27 82.034h8.399v8.399h-8.399z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.628 97.592h8.4v8.399h-8.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m40.27 97.592h8.399v8.399h-8.399z"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m93.257 30.099h6.945v57.207h-6.945z",
  fill: "#547982"
});

var SvgPos = function SvgPos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 128 128",
    width: 512,
    "data-name": "Layer 1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pos.d39f114e.svg";
export { ForwardRef as ReactComponent };